import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AdminCategoryMetricsDTO, AdminCategorySearchDTO, AdminCategorySearchResponseDTO, AggregatedCategoryMetricsDTO, Category, CategoryDTO } from './category';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {
    private readonly _baseUrl = `admin/category`;

    constructor(private _httpClient: HttpClient) { }

    /**
     * Search categories
     * @param search 
     */
    search(search: AdminCategorySearchDTO): Observable<AdminCategorySearchResponseDTO> {
        const params: any = {};
        Object.entries(search).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params[key] = value;
            }
        });
        return this._httpClient.get<AdminCategorySearchResponseDTO>(`${this._baseUrl}/search`, {
            params
        });
    }

    /**
     * Get category metrics (Legacy/Fallback)
     */
    getMetrics(): Observable<AdminCategoryMetricsDTO[]> {
        return this._httpClient.get<AdminCategoryMetricsDTO[]>(`${this._baseUrl}/metrics`).pipe(
            catchError(() => {
                return of([
                    {
                        id: '676816409930f23075677b21',
                        name: 'Autos e Peças',
                        icon: 'directions_car',
                        activeAdsCount: 150,
                        conversionRate: 12.5,
                        trend: 'UP',
                        status: 'ACTIVE'
                    },
                    {
                        id: '676816409930f23075677b22',
                        name: 'Eletrônicos',
                        icon: 'devices',
                        activeAdsCount: 85,
                        conversionRate: 8.2,
                        trend: 'DOWN',
                        status: 'ACTIVE'
                    }
                ] as AdminCategoryMetricsDTO[]);
            })
        );
    }
   
    listAnalyticalMetrics(): Observable<AggregatedCategoryMetricsDTO> {
        return this._httpClient.get<AggregatedCategoryMetricsDTO>(`${this._baseUrl}/listAnalyticalMetrics`).pipe(
            catchError(() => of({
    totalActiveAds: 150,
    totalSubcategories: 12
} as AggregatedCategoryMetricsDTO))

        );
    }

    /**
     * Update category
     * @param id 
     * @param category 
     */
    update(id: string, category: CategoryDTO): Observable<CategoryDTO> {
        return this._httpClient.put<CategoryDTO>(`${this._baseUrl}/${id}`, category);
    }

    /**
     * Update category status
     * @param id 
     * @param status 
     */
    updateStatus(id: string, status: 'ACTIVE' | 'BLOCKED'): Observable<any> {
        return this._httpClient.post(`${this._baseUrl}/${id}/status`, null, {
            params: { status }
        });
    }

    reorderCategories(orders: { id: string; priority_order: number }[]): Observable<any> {
        return this._httpClient.post(`${this._baseUrl}/reorder`, orders);
    }

    save(category: Category, callback?: (result: any, resp: any) => void): void {
        this._httpClient.post('categories/save', category).subscribe(response => {
            if (callback) {
                callback(null, response);
            }
        });
    }

}
